import axios from 'axios'
import { API_URL } from '../../../../../constants'
import {
  IMerchantDetailRes,
  IMerchantActiveCurrencyRes,
  IMerchantBalancePolicyRes,
  MerchantCurrency,
} from './types'

export const getMerchantDetail = (id: number) => {
  return axios.get<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}`)
}

export const resetEmployeePassword = (id: number, password: string) => {
  return axios.post(`${API_URL}/api/internal/employee/edit/${id}`, {
    password,
  })
}

// Тот же маршрут, что и у карточки сотрудника — отдельного merchant/{id}/operators нет
// и заводить его не нужно (CPAYMENT-1673). Тело запроса пустое, в ответе профиль сотрудника.
// Ручка снимает привязку и оператора (merchants_operators), и менеджера мерчанта
// (merchants_managers) — join-таблицу бэкенд выбирает по типу сотрудника.
export const detachEmployeeFromMerchant = (employeeId: number, merchantId: number) => {
  return axios.delete(`${API_URL}/api/internal/employee/${employeeId}/merchants/${merchantId}`)
}

export const getMerchantActiveCurrency = (id: number) => {
  return axios.get<IMerchantActiveCurrencyRes>(`${API_URL}/api/internal/merchant/${id}/active-currency`)
}

export const setMerchantActiveCurrency = (id: number, currency: MerchantCurrency) => {
  return axios.put<IMerchantActiveCurrencyRes>(`${API_URL}/api/internal/merchant/${id}/active-currency`, { currency })
}

// CPAYMENT-1692: precheck адаптеров при создании депозита (can-match). Ручка доступна
// только admin/manager — тумблер под неё рисуем с тем же гейтом.
export const setMerchantDepositPrecheck = (id: number, enabled: boolean) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/deposit-precheck`, {
    depositPrecheckEnabled: enabled,
  })
}

// Гашение дублей депозитов клиента: прежние незавершённые депозиты гаснут, когда он создаёт новый. По умолчанию
// включено; выключают мерчантам, у которых один внешний id — это касса с многими плательщиками.
export const setMerchantDepositSupersede = (id: number, enabled: boolean) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/deposit-supersede`, {
    depositSupersedeEnabled: enabled,
  })
}

// Таймаут платёжной страницы для matching-депозитов, в минутах; null возвращает общий порог.
export const setMerchantPaymentPageTimeout = (id: number, minutes: number | null) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/payment-page-timeout`, {
    paymentPageTimeoutMinutes: minutes,
  })
}

// Белый список IP для API мерчанта: список и переключатель сохраняются вместе.
export const setMerchantApiIpAllowlist = (id: number, body: { enabled: boolean; entries: string[] }) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/api-ip-allowlist`, body)
}

// Порог автоостановки matching-выплат мерчанта; null возвращает порог платформы.
export const setMerchantMatchingAutoHaltClients = (id: number, clients: number | null) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/matching-auto-halt-clients`, {
    matchingAutoHaltClients: clients,
  })
}

export const setMerchantVariantFallback = (
  id: number,
  body: { variantFallbackPgEnabled?: boolean; variantFallbackH2hEnabled?: boolean }
) => {
  return axios.patch<IMerchantDetailRes>(`${API_URL}/api/internal/merchant/${id}/variant-fallback`, body)
}

export const getMerchantBalancePolicy = (id: number) => {
  return axios.get<IMerchantBalancePolicyRes>(`${API_URL}/api/internal/merchant/${id}/balance-policy`)
}

export const setMerchantBalancePolicy = (
  id: number,
  body: { enforceBalance: boolean; overdraftLimit: string }
) => {
  return axios.post<IMerchantBalancePolicyRes>(`${API_URL}/api/internal/merchant/${id}/balance-policy`, body)
}
